import { Box, Grid, makeStyles, Typography } from "@material-ui/core";
import React from "react";

interface FullWidthBigBlockProps {
  headlineOne: String;
  headlineTwo?: String;
  p1?: String;
  p2?: String;
  bgImg?: String;
  bgColor: String;
  bgPositionDesktop?: String;
  bgPositionMobile?: String;
  color:
    | "inherit"
    | "initial"
    | "primary"
    | "secondary"
    | "textPrimary"
    | "textSecondary"
    | "error";
}

const useStyles = makeStyles((theme) => ({
  mainWrapperColCenter: (props: FullWidthBigBlockProps) => ({
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "75vh",
    backgroundRepeat: "no-repeat",
    backgroundPosition: `${props.bgPositionDesktop}`,
    backgroundSize: "cover",
    backgroundImage: `url(${props.bgImg})`,
    backgroundColor: `${props.bgColor}`,
    [theme.breakpoints.down("sm")]: {
      height: "75vh",
      paddingTop: theme.spacing(3),
      paddingRight: theme.spacing(3),
      paddingBottom: theme.spacing(4),
      paddingLeft: theme.spacing(3),
      backgroundPosition: `${props.bgPositionMobile}`,
    },
  }),
  headlineWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "8px",
    marginBottom: theme.spacing(4),
    [theme.breakpoints.down("xs")]: {
      alignItems: "flex-start",
    },
  },
  bodyWrapper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "24px",
    [theme.breakpoints.down("xs")]: {},
  },
  h1bas: {
    fontSize: "80px !important",
    lineHeight: "80px !important",
    letterSpacing: -2,
    [theme.breakpoints.down("xs")]: {
      fontSize: "48px !important",
      letterSpacing: -2,
      lineHeight: "48px !important",
    },
  },
  h4bas: {
    fontSize: "24px",
    lineHeight: "32px",
    color: "#ffffff",
    [theme.breakpoints.down("xs")]: {
      fontSize: "18px",
      lineHeight: "28px",
    },
  },
}));

export const FullWidthBigBlock: React.FC<FullWidthBigBlockProps> = (props) => {
  const { headlineOne, headlineTwo, p1, p2, children } = props;
  const classes = useStyles(props);

  return (
    <Grid item xs={12} md={12}>
      <Box className={classes.mainWrapperColCenter}>
        <Box className={classes.headlineWrapper}>
          <Typography
            variant="h1"
            className={classes.h1bas}
            color={props.color}
            align={"center"}
          >
            {headlineOne}
          </Typography>
          <Typography
            variant="h1"
            className={classes.h1bas}
            color={props.color}
          >
            {headlineTwo}
          </Typography>
        </Box>
        <Grid container justify="center">
          <Grid item xs={12} md={6}>
            <Box className={classes.bodyWrapper}>
              <Typography
                variant="h4"
                className={classes.h4bas}
                align={"center"}
              >
                {p1}
              </Typography>
              <Typography
                variant="h4"
                className={classes.h4bas}
                align={"center"}
              >
                {p2}
              </Typography>
              {children}
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Grid>
  );
};
